// A birth date (or any "day only", no time-of-day meaning) must not go through
// Date.prototype.toISOString() for transport — that converts using the
// browser's local UTC offset, so a locally-picked midnight silently shifts
// into the previous UTC day for anyone east of UTC (e.g. 10.09.2010 in Vienna
// becomes 2010-09-09T22:00:00.000Z). Always send these as a plain YYYY-MM-DD
// string built from the Date's local components instead.
export function toDateOnlyString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
